<template>
  <div v-if="searchResultHits && searchResultHits.length > 0">
    <div
      id="searchresulttotal"
      v-if="!showAnswer"
      class="total"
      aria-live="polite"
      tabindex="-1"
    >
      {{ totalMatchingText }}
    </div>
    <ul class="searchresultlist" v-if="!showAnswer">
      <SearchResultItem
        v-for="hit in searchResultHits"
        :key="hit.id"
        :hit="hit"
        :texts="texts"
        :searchType="searchType"
        :showBreadcrumb="showBreadcrumb"
      ></SearchResultItem>
    </ul>
  </div>
  <p v-else>{{ texts.noResult }}</p>
  <ChatAnswer
    v-if="showAnswer"
    :chatgptanswer="chatgptanswer"
    :texts="texts"
    :isLoading="isLoading"
    :error="error"
  ></ChatAnswer>
</template>
<script>
import SearchResultItem from "./searchresultitem.vue";
import sitesearchservice from "../../plugins/sitesearchservice";
import ChatAnswer from "./chatanswer.vue";

export default {
  name: "SearchResult",
  props: {
    searchResultHits: Array,
    totalMatchingText: String,
    texts: Object,
    showAnswer: Boolean,
    sokOptions: Object,
    query: String,
    searchType: String,
    showBreadcrumb: Boolean,
  },
  data: function () {
    return {
      chatgptanswer: [],
      isLoading: false,
      error: false,
    };
  },
  components: {
    SearchResultItem,
    ChatAnswer,
  },
  mounted() {
    if (this.showAnswer) {
      this.getResult();
    }
  },
  methods: {
    getResult() {
      this.isLoading = true;
      sitesearchservice
        .getAnswer(this.$baseApiUrl, this.query, this.sokOptions)
        .then((result) => {
          if (result && result.status === 200) {
            var t = JSON.stringify(result.data);
            t = t.replace(/null/g, "");
            t = t.replace(/\[doc/g, "[referens ");
            t = t.replace(/"/g, "");
            t = t.replace(/,/g, "");
            t = t.replace(/,/g, "");
            t = t.replace(/\\n/g, " ");
            t = t.replace(/\\/g, "");
            t = t.slice(1, -1);
            this.chatgptanswer = t;
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.error = true;
          console.log(err);
          this.isLoading = false;
        });
    },
  },
};
</script>
